module.exports = __webpack_public_path__ + "img/A6.dd983925.png";